import { formatMoney } from '../../../../../utils/string';

interface IParams {
  totalPrice: number;
  isNewOffer: boolean;
  isSubscriptionSelected: boolean;
  isPublishToHiddenBase: boolean;
}

export function getPublishButtonText(params: IParams): string {
  const { totalPrice, isNewOffer, isSubscriptionSelected, isPublishToHiddenBase } = params;

  switch (true) {
    case isPublishToHiddenBase && isNewOffer:
      return 'Разместить';

    case isPublishToHiddenBase && !isNewOffer:
      return 'Сохранить';

    case isSubscriptionSelected:
      return 'Купить пакет и разместить';

    case !!totalPrice && isNewOffer:
      return `Оплатить ${formatMoney(totalPrice)} и разместить`;

    case !!totalPrice && !isNewOffer:
      return `Оплатить ${formatMoney(totalPrice)} и сохранить`;

    case !isNewOffer:
      return 'Сохранить';

    case isNewOffer:
    default:
      return 'Разместить';
  }
}
